import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import styled from "styled-components";
import { GreenhouseDepartment } from "../types";

interface Props {
  department: GreenhouseDepartment;
  selectedLocationName: string;
}

const DepartmentJobs: FC<Props> = withErrorBoundary(({ department, selectedLocationName }) => {
  const jobs = department.jobs.filter((job) => {
    return job.location.name.includes(selectedLocationName) || job.location.name.includes("All Locations");
  });

  return (
    <StyledDepartmentJobs>
      {jobs.map(({ title, location, absolute_url }, index) => (
        <div key={index} className="TableOpenRolesDepartmentJob">
          <div className="TableOpenRolesDepartmentJob__linkContainer">
            <a
              className="TableOpenRolesDepartmentJob__link"
              href={absolute_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <h4 className="TableOpenRolesDepartmentJob__title Color_secondary Font_16_22_450">{title}</h4>
            </a>
          </div>

          <div className="TableOpenRolesDepartmentJob__location Color_secondary Font_16_22_450">{location.name}</div>
        </div>
      ))}
    </StyledDepartmentJobs>
  );
}, {});

const StyledDepartmentJobs = styled.div`
  .TableOpenRolesDepartmentJob {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
  }

  .TableOpenRolesDepartmentJob > * {
    flex: 1;
  }

  .TableOpenRolesDepartmentJob__link {
    display: inline-flex;
  }

  .TableOpenRolesDepartmentJob__link:hover {
    opacity: 0.6;
  }

  .TableOpenRolesDepartmentJob__location {
    display: flex;
    justify-content: flex-end;
    margin-left: 16px;
    text-align: right;
  }

  .TableOpenRolesDepartmentJob:not(:first-child) {
    margin-top: 16px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    .TableOpenRolesDepartmentJob {
      padding: 0;
    }
  }
`;

export { DepartmentJobs };
